






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState } from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import util from '@/lib/util';
import Contacts from '@/views/Contacts.vue';


@Component({  
  components: {
      RotateSquare2,VueElementLoading
},
computed: {
...mapState({
  'devices': (state: StoreState) => (state.account as any).devices,
  'Tag_status': (state: StoreState) => state.dashboard.Tag_status,
  'Tab_Mang': (state: StoreState) => state.dashboard.Tab_Mang,
  'Tab_Action': (state: StoreState) => state.dashboard.Tab_Action,
  'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
  'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,
  'handletagsidebar' : (state: StoreState) => state.dashboard.handletagsidebar,
  'Managing_Tag': (state: StoreState) => state.dashboard.Managing_Tag,
  'tagname':(state:StoreState) => state.dashboard.tagname,
})
},
})
export default class TAGCRUD extends Vue {
   @Prop()
    public multipleselect;

  data() {
   return {
    submitted:false,
    is_loading: false,
    selectedDevice: null,
    not_exists:[],
    exists:[],
    tag_name: '',
    err:"",
    oldsidetag: "",
    edittagname:"",
    placeholder:"Type here",
    Local_NEWTAGLIST:[]
       
   }
  }
mounted() {
  this.$data.oldsidetag = (this as any).Tab_Action.tag;
  this.$data.edittagname = (this as any).Tab_Action.tag;

}
@Watch('tabaction')
 onChangetabaction()
 {
   this.$data.oldsidetag = (this as any).Tab_Action.tag;
 }
edittagclose(tgname)
{
  
   var isedit = tgname+'isedit'
       let ele = document.getElementById((this as any).Tab_Action._id);
       ele.classList.remove('edittagbgactive');
       var editiconclicked = tgname +"iseditclicked";
    let elm = document.getElementById(editiconclicked);
   elm.classList.remove("editicontest");
   for(let i=0;i<ele.classList.length;i++)
    {
      if(ele.classList[i] == 'clistactive')
       {
         ele.classList.remove('clistactive');
       }
       if((this as any).contactsidebar_status == this.$data.oldsidetag){
         ele.classList.add('clistactive');
       }
    }
    if((this as any).selectedContact)
    {
      (this as any).selectedContact.forEach((e)=> {
        var check = e._id;
         let ele = document.getElementById(check);
        ele.classList.remove('checkboxbg');
      })
    }
     
      
   
    
}

   addtoshate()
  {
    var multipleselect=(this as any).Tab_Mang.evt.multiselect;
    var  fnl = multipleselect.filter(e => {
      delete e._id; delete e._rev; delete e.owner_id;e.private=false; e.Favoritecontact = [];//
          return e;
      });
    this.$data.is_loading=true;  
    this.$store.dispatch('addtoshareContac', fnl).then(r => {
    this.$data.is_loading=false; 
    this.$store.commit('TAB_STATUS',false);
    this.$store.commit('CONTACT_SIDEBARSTATSU', 'shared');
    this.$emit('tagevent','refresh_listdata');
      })
  }
  
 
   saveTag(tagname)
  {
   this.$data.submitted = true;
    let tags = util.handletag();  
   let tgs = util.handletag();
   var create_from=(this as any).Tab_Mang;
   for(var i =0; i<tgs.length;i++)
   {
     if(tagname == tgs[i].tag)
     {
       alert("Name already exists");
       return false;
     }
   }
   console.log('hereingthi',create_from);
  
   console.log('tags',tags);
   if(tagname!= ""){
      console.log('hereidfsd',tagname);
    this.$data.is_loading=true;  
     if(tags.map(e=>e.tag).indexOf(tagname)== -1)
      {
          let TAG_ID='';
          //Create new tag
          this.$store.dispatch('savetag', tagname).then(r=>{
          tags.push({tag: tagname, contact_count: 0, _id: r.data.id, _rev: r.data.rev});
          util.handletag(tags, 'set');   
          let TAG_List123 = tags;      
          this.$data.is_loading=false; 
          TAG_ID=r.data.id;
          //Create new tag from MainMenuTag
          console.log('tags her',tags);
          console.log('create_from.from',create_from);
          if(create_from.from=="Create_fromMaintag") {
              var multipleselect=(this as any).Tab_Mang.multiselect;
              let contact_arr = [];
              for(let i = 0; i < multipleselect.length; i++)
              {
                contact_arr.push(multipleselect[i]._id);
                var check = multipleselect[i]._id;
              }
              let payload = {payload: {contactid: contact_arr, taglist: [TAG_ID]}};
              //Assign created new tag to contcats
              this.Assigntag_to_multipleContact(TAG_ID,payload,multipleselect,tagname);
          } 

         //Create NewTag from Table MenuTag
         if(create_from.from=='Create_fromTable'){
           //Assign created new tag to selected contcat
           console.log("hereassigning");
            this.AssignTag_to_tablecontact(TAG_ID,tagname);
         }
         
         //Create NewTag from DetailContact page
          if(create_from.from=='Create_fromDetail'){
            if(create_from.editdetail=='details') {
              this.AssignTag_to_Detailcontact(TAG_ID,create_from.editdetail,tagname);
            }
            else{
              var selected_contc=(this as any).selectedContact;
              //selected_contc.taglist.push(TAG_ID);
              console.log('hereit is',tagname);
              if(create_from.editdetail=='textmsg') {
                  this.AssignTag_to_Detailcontact(TAG_ID,'textmsg',tagname);
              } else{
                 this.AssignTag_to_Detailcontact(TAG_ID,'details',tagname);
              }
              
              //this.UpdateTag_Contact(TAG_ID,tagname);
            }
          } 
          //Create NewTag from NewContact page
          if(create_from.from=='Create_fromNewContact'){
            this.$data.Local_NEWTAGLIST.push(TAG_ID);    
            this.$store.commit('NEW_TAGIST',this.$data.Local_NEWTAGLIST);
          }
         
          this.$store.commit('TAB_STATUS' ,false);
        }).catch(e=>{
          this.$data.is_loading=false; 
          this.$store.commit('TAB_STATUS' ,false);
        })
      }
   }
   
  }


  AssignTag_to_Detailcontact(TAGID ,fromdetailtag,tagname){
      var selected_contc=(this as any).selectedContact;
       var another_selectcontact = selected_contc;
      another_selectcontact.taglist.push(TAGID);
      this.$store.dispatch('assignTagtoContact', another_selectcontact).then(async r => { 
        //Refresh contact
        //$root is used for non-parent-child relationship
        //refer this link
        //https://stackoverflow.com/questions/42990308/vue-js-how-to-call-method-from-another-component
      
        if(fromdetailtag=='details' || fromdetailtag=='textmsg'){ console.log('hereiam');
          await this.UpdateTag_Contact(TAGID,tagname);
          await this.updateTagCount(TAGID,selected_contc, true, 'single');
          if(fromdetailtag=='details') { this.$root.$emit('contact_table',{tagid:TAGID,type:'assign'}); }
          }}).catch(() => {});
  }

  AssignTag_to_tablecontact(TAGID,tagname){
    var selected_contc=(this as any).selectedContact;
    console.log('tagid',TAGID);
    let payload = {payload: {contactid:[selected_contc._id], taglist: [TAGID]}};
      this.$store.dispatch("assigntag",payload).then(async r=>{
        //Update TagCount
        await this.UpdateTag_Contact(TAGID,tagname);
        //Update created tag to selectedd contact
        await this.updateTagCount(TAGID, selected_contc, true, 'single');
        this.$data.is_loading=false;
      },err=>{
        this.$data.is_loading=false;
        alert("failed")
      })
      .catch(err=>{
        alert("failed")
      });
  }

  Assigntag_to_multipleContact(TAG_ID,payload,multipleselect,tagname){
      this.$store.dispatch("assigntagmulti",payload).then(r=>{
      //Update Tagcount  
      this.updateTagCount(TAG_ID, multipleselect, true,'multiple');
      //update created tag to contacts
      this.UpdateTag_Contact(TAG_ID,tagname);
      },err=>{
        alert("failed");
      })
      .catch(err=>{
        alert("failed");
      });
  }

  async UpdateTag_Contact(TAG_ID,tagname){
      let conta = (this as any).selectedContact;console.log('contacd',conta);
      if(conta.length>=1){ 
        for(var j=0;j<conta.length;j++)
        {
        let count= conta.length;           
        let ele = document.getElementById(conta[j]._id);
        ele.classList.remove('checkboxbg');
          if(!conta[j].taglist) conta[j].taglist = []
          if(!conta[j].tags1) conta[j].tags1 = []
          
           let checkExist = {};
            checkExist = await conta[j].tags1.filter(function(cont) { 
               return cont._id==TAG_ID
            })
            let checkTagExist = {};
            checkTagExist = await conta[j].taglist.filter(function(contl) { 
               return contl==TAG_ID
            })
          
           if(Object.keys(checkExist).length==0) {
                 conta[j].tags1.push({pvt_type:'tag',tag:tagname,_id:TAG_ID})
                 
           }
           if(Object.keys(checkTagExist).length==0) {
                conta[j].taglist.push(TAG_ID)
           }


          //conta[j].tags1.push({pvt_type:'tag',tag:tagname,_id:TAG_ID})
          //conta[j].taglist.push(TAG_ID)
        }
      }
      else{
        if(!conta.taglist) conta.taglist = []
        if(!conta.tags1) conta.tags1 = []
        let checkExist = {};
            checkExist = await conta.tags1.filter(function(cont) { console.log('contacttag',cont._id);
                return cont._id===TAG_ID
            })
            let checkTagExist = {};
            checkTagExist = await conta.taglist.filter(function(contl) { console.log('taglistid',contl);
               return contl==TAG_ID
            })
          
            if(Object.keys(checkExist).length==0) {
                conta.tags1.push({pvt_type:'tag',tag:tagname,_id:TAG_ID})
                
            }
            if(Object.keys(checkTagExist).length==0) {
                conta.taglist.push(TAG_ID);
            }

          //conta.tags1.push({pvt_type:'tag',tag:tagname,_id:TAG_ID})
          //conta.taglist.push(TAG_ID)
      }
  }

  async updateTagCount(tag_id='',  contact, flag,type) 
  {
    if(type=='multiple'){
      let count = contact.length;
      debugger
      let tags = util.handletag();
      debugger
      let tindex = tags.map(e=>e._id).indexOf(tag_id);
      let temp_count = tags[tindex].contact_count ? tags[tindex].contact_count : 0;
      for(let i = 0; i < count; i++){
      if(contact[i].taglist.indexOf(tag_id) == -1) temp_count += 1;
      tags[tindex].contact_count = temp_count;
      debugger
      util.handletag(tags, 'set');
      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!flag);
      //temp_count = 0;
      }
    }
    else{
      let tags = util.handletag();
      let tindex = tags.map(e=>e._id).indexOf(tag_id);
      tags[tindex].contact_count += 1;
      util.handletag(tags, 'set');
      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!flag);
    }
  }
  
  onCancelTag()
  {
    if((this as any).selectedContact)
    {
      (this as any).selectedContact.forEach((e)=> {
        var check = e._id;
         let ele = document.getElementById(check);
        ele.classList.remove('checkboxbg');
      })
    }
  }

  editTag(tagname,tgname)
  {
    var isedit = tgname+'isedit';
    let ele = document.getElementById((this as any).Tab_Action._id);
   if(ele) ele.classList.remove('edittagbgactive')
    var editiconclicked = tgname +"iseditclicked";
    let elm = document.getElementById(editiconclicked);
   if(elm) elm.classList.remove("editicontest");
  this.$data.submitted = true;
    if(tagname == (this as any).Tab_Action.tag)
   {
     this.$data.is_loading=false; 
      alert('Name already exists')
      elm.classList.add("editicontest");
      ele.classList.add('edittagbgactive');
      return;
   }
   if(util.handletag().map(e=>e.tag.trim()).indexOf(tagname.trim()) > -1)
   {
     this.$data.is_loading=false; 
      alert('Name already exists')
      elm.classList.add("editicontest");
       ele.classList.add('edittagbgactive');
      return;
   }
  if(tagname != ""){
      this.$data.err = "";
    this.$data.is_loading=true; 
    (this as any).Tab_Action.tag = tagname; 
    for(let i=0;i<ele.classList.length;i++)
    {
      if(ele.classList[i] == 'clistactive')
       {
         ele.classList.remove('clistactive');
       }
       if((this as any).contactsidebar_status == this.$data.oldsidetag){      
         ele.classList.add('clistactive');
       }
    }
    var payload = {payload: (this as any).Tab_Action};
    this.$store.dispatch('updatetag', payload).then(r=>{
      var dd = r;
    this.$data.is_loading=false;  
    var nn=payload
    this.$store.commit('TAB_STATUS',false);
    this.$emit('tagevent', 'UpdateTagContacts' ,payload)
    //this.$store.commit('CONTACT_SIDEBARSTATSU', 'personal');
    })
    .catch(err=>{    
      this.$data.is_loading=false;  
      this.$store.commit('TAB_STATUS',false);
    })
    if((this as any).selectedContact){      
     (this as any).selectedContact.forEach((e)=> {
        var check = e._id;
         let ele = document.getElementById(check);
        ele.classList.remove('checkboxbg');
      })
    }
  }
   
  }
  deletetag(tag)
  {
    console.log('contactsidebarselected',(this as any).contactsidebar_status);
    var isedit = tag.tag+'isedit';
    let ele = document.getElementById(isedit);
  //  if(ele) ele.classList.remove('edittagbgactive')
    var editiconclicked = tag.tag +"iseditclicked";
    let elm = document.getElementById(editiconclicked);
  if(elm) elm.classList.remove("editicontest");
    this.$data.is_loading=true;  
    let payload = {payload: (this as any).Tab_Action};
     let tags = util.handletag();
    this.$store.dispatch('deletetag', payload).then(r=>{
      let selected_taglist = (this as any).tagname;
       console.log('selected_taglist before',selected_taglist);
       selected_taglist.splice(selected_taglist.indexOf(payload.payload._id),1);
      console.log('selected_taglist after',selected_taglist);
      console.log('payload delete tag',payload);
      this.$store.commit("SET_TAG_NAME", selected_taglist);
    this.$data.is_loading=false;      
      tags.splice(tags.map(e=>e._id).indexOf(payload.payload._id),1)
      util.handletag(tags, 'set');
       let TAG_List123 = tags;
      this.$store.commit('TAB_STATUS' ,false);
      this.$emit('tagevent', 'DeleteTagContacts' ,payload);
      const list =  document.querySelectorAll('.edittagbgactive ');
      list[0].classList.remove('edittagbgactive');     
      list[0].classList.remove('istagactivebg');
       const tagicon = document.querySelectorAll('.istagiconinactive');
       tagicon.forEach((el)=>{
        if(el.id == ((tag._id)+"tagicon")) el.classList.remove('istagiconinactive');
       })
      

    // this.$store.commit('CONTACT_SIDEBARSTATSU', 'personal');
    })
    .catch(err=>{
    this.$data.is_loading=false;  
    this.$store.commit('TAB_STATUS',false);
    })
  }

}
